import { config } from '../config';
import { getHeaders } from './getHeaders';

export const getConsultants = (token: string) =>
  fetch(`${config.classificationUrl}/api/v1/sales-consultants`, {
    headers: getHeaders(token),
  });
